export const weekdays = [
  'calendar_Sun',
  'calendar_Mon',
  'calendar_Tue',
  'calendar_Wed',
  'calendar_Thu',
  'calendar_Fri',
  'calendar_Sat',
];

export const months = [
  'calendar_January',
  'calendar_February',
  'calendar_March',
  'calendar_April',
  'calendar_May',
  'calendar_June',
  'calendar_July',
  'calendar_August',
  'calendar_September',
  'calendar_October',
  'calendar_November',
  'calendar_December',
];

export const monthsShort = [
  'calendar_Jan',
  'calendar_Feb',
  'calendar_Mar',
  'calendar_Apr',
  'calendar_May',
  'calendar_Jun',
  'calendar_Jul',
  'calendar_Aug',
  'calendar_Sep',
  'calendar_Oct',
  'calendar_Nov',
  'calendar_Dec',
];

export const START = 'start';
export const END = 'end';
export const PREV = 'prev';
export const NEXT = 'next';
export const DAY = 'day';
export const MONTH = 'month';
export const YEAR = 'year';
export const CURRENT = 'current';
export const DISABLED = 'DISABLED' as const;
